import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { AuthService } from "src/rest/authService";

interface AuthState {
    accessToken: string | null;
    isAuthenticated: boolean;
    isRefreshing: boolean;
}

const initialState: AuthState = {
    accessToken: null,
    isRefreshing: false,
    isAuthenticated: false
};


export const refreshTokenThunk = createAsyncThunk<
  string,            // return type
  void,              // argument type
    { rejectValue: string }
    >('auth/refreshToken',
    async (_, thunkAPI) => {
        try {
            const response = await AuthService.refreshToken();
            return response.data.token;
        } catch (error: any) {
            return thunkAPI.rejectWithValue('Refresh token expired');
        }
    }
);

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setCredentials(state, action: PayloadAction<string>) {
        state.accessToken = action.payload;
        state.isAuthenticated = true;
        },
        logout(state) {
        state.accessToken = null;
        state.isAuthenticated = false;
        }
    },
    extraReducers: builder => {
        builder
        .addCase(refreshTokenThunk.pending, (state) => {
            state.isRefreshing = true;
        })
        .addCase(refreshTokenThunk.fulfilled, (state, action) => {
            state.accessToken = action.payload;
            state.isAuthenticated = true;
            state.isRefreshing = false;
        })
        .addCase(refreshTokenThunk.rejected, (state) => {
            state.accessToken = null;
            state.isAuthenticated = false;
            state.isRefreshing = false;
        });
    }
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;